import React from "react";
import styles from "./Event.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Link from "next/link";
import Image from "next/image";

const PrevArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <button
      className={`${className} ${styles.arrow} ${styles.prevArrow}`}
      onClick={onClick}
    >
      <Image
        className={styles.arrowBGWhite}
        src="/assets/Chevron-left.svg"
        alt="arrow-left"
        title="arrow-left"
        width={32}
        height={32}
      />
    </button>
  );
};

const NextArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <button
      className={`${className} ${styles.arrow} ${styles.nextArrow}`}
      onClick={onClick}
    >
      <Image
        className={styles.arrowBGWhite}
        src="/assets/Chevron-right.svg"
        alt="arrow-right"
        title="arrow-right"
        width={32}
        height={32}
      />
    </button>
  );
};

const Events = ({ data, title }: any) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const hasMultipleSlides = data.length > 1;

  const settings = {
    dots: hasMultipleSlides,
    infinite: hasMultipleSlides,
    speed: 500,
    fade: true,
    autoplaySpeed: 7000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    slidesToShow: 1,
    slidesToScroll: 1,

    appendDots: (dots: React.ReactNode) => {
      const isMobile =
        typeof window !== "undefined" && window.innerWidth <= 768;
      return (
        <div
          style={{
            position: "absolute",
            bottom: isMobile ? "-36px" : "-56px",
            width: "100%",
          }}
        >
          <ul
            style={{
              margin: 0,
              padding: 0,
              display: "flex",
              justifyContent: "center",
            }}
          >
            {dots}
          </ul>
        </div>
      );
    },
  };

  return (
    <div className={styles.eventRow}>
      <div className="container">
        <div className="breadCrumbEvents">
          <Breadcrumbs classValue="eventsStyle" />
        </div>
        <h1 className={styles.title}>{title}</h1>

        <Slider {...settings} className={styles.slider}>
          {data?.map((event: any) => (
            <Link key={event?.id} href={event?.type_link?.url || ""} passHref>
              <div className={styles.eventCard}>
                <div className={styles.evenstFlex}>
                  <div className={styles.responsiveImageContainer}>
                    {/* Desktop image */}
                    <div className={styles.desktopImage}>
                      <Image
                        src={event?.banner?.desktop_img?.url}
                        alt={event?.banner?.desktop_img?.title || "Event Image"}
                        title={
                          event?.banner?.desktop_img?.title || "Event Image"
                        }
                        className={styles.image}
                        width={540}
                        height={364}
                        layout="intrinsic"
                      />
                    </div>
                    {/* Mobile image */}
                    {event?.banner?.mobile_img?.url && (
                      <div className={styles.mobileImage}>
                        <Image
                          src={event?.banner?.mobile_img?.url}
                          alt={
                            event?.banner?.desktop_img?.title || "Event Image"
                          }
                          title={
                            event?.banner?.desktop_img?.title || "Event Image"
                          }
                          className={styles.image}
                          width={540}
                          height={364}
                          layout="intrinsic"
                        />
                      </div>
                    )}
                  </div>
                  <div className={styles.details}>
                    <div className={styles.flexEventDetails}>
                      <strong
                        className={`${styles.badge} ${
                          styles[event?.type_link.url?.toLowerCase()]
                        }`}
                      >
                        {event?.type_link?.label}
                      </strong>

                      <span className={styles.date}>
                        {formatDate(event?.date)}
                      </span>
                    </div>
                    <p className={styles.eventTitle}>
                      {event?.banner?.description}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Events;
